import React from 'react';
import { LookupObject } from 'src/types/shared/Challenge';

const months: string[] = [
    'January',
    'February',
    'March',
    'April',
    'May',
    'June',
    'July',
    'August',
    'September',
    'October',
    'November',
    'December',
];

const CalendarMonthHeader: React.FC<CalendarMonthHeaderProps> = ({
    month,
    index,
    length,
    style,
}) => {
    const fD = { y: month.from.y, m: month.from.m, d: month.from.d };
    const tD = { y: month.to.y, m: month.to.m, d: month.to.d };

    const gridRowStart = 'rows-start';
    const gridColumnStart = index === 0 ? 'sidebar-end' : `start-${fD.y}-${fD.m}-${fD.d}`;
    const gridRowEnd = 'header-month-end';
    const gridColumnEnd = index === length - 1 ? 'cols-end' : `end-${tD.y}-${tD.m}-${tD.d}`;

    const monthHeaderStyles = {
        gridArea: `${gridRowStart} / ${gridColumnStart} / ${gridRowEnd} / ${gridColumnEnd}`,
    };

    return (
        <div className="month-header" style={{ ...monthHeaderStyles, ...style }}>{`${
            months[+fD.m - 1]
        } ${fD.y}`}</div> // TODO fix this
    );
};

interface CalendarMonthHeaderProps {
    month: LookupObject;
    index: number;
    length: number;
    style?: React.CSSProperties;
}

export default CalendarMonthHeader;
